export default "__VITE_ASSET__25431e2c__"